import { render, staticRenderFns } from "./ruleIndex.vue?vue&type=template&id=eb80ac20&"
import script from "./ruleIndex.vue?vue&type=script&lang=js&"
export * from "./ruleIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports